<template>
  <div class="pricing-form input-group">
    <dg-input type="number" v-model="formData.monthlyFee" placeholder="Monthly fee" icon="dollar-sign" />
    <div class="t-fee">
      <dg-input type="number" v-model="formData.transactionFee" placeholder="Transaction fee" hide-placeholder icon="percent" />    
      <el-slider
        @mousedown.native="isSliding = true"
        @mouseup.native="isSliding = false"
        :show-tooltip="false"
        class="slider"
        v-model="formData.parsedFee"
        :step="0.1"
        :max="20">
      </el-slider>
    </div>
    <el-button type="primary" icon="el-icon-upload" class="action-button" @click="emitFormData">Save organization</el-button>
  </div>
</template>

<script>
export default {
  name: 'PricingForm',
  props: {
    monthly: [Number],
    fee: [Number],
    accountNumber: [String]
  },
  data () {
    return {
      isSliding: false,
      formData: {
        monthlyFee: this.monthly !== null ? this.monthly.toString() : null,
        transactionFee: this.fee !== null ? this.fee.toString() : null,
        parsedFee: this.fee || 0
      }
    }
  },
  watch: {
    'formData.transactionFee' (val) {
      const parsedVal = parseFloat(this.formData.transactionFee)
      if (parsedVal > 20) {
        this.formData.parsedFee = 20
      } else {
        this.formData.parsedFee = parseFloat(this.formData.transactionFee)
      }
    },
    'formData.parsedFee' (val) {
      if (this.formData.transactionFee <= 20 || this.isSliding) {
        this.formData.transactionFee = this.formData.parsedFee.toString()
      }
    }
  },
  methods: {
    emitFormData () {
      this.$emit('create', {
        monthlyFee: parseFloat(this.formData.monthlyFee),
        transactionFee: parseFloat(this.formData.transactionFee)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .action-button {
    margin-top: 30px;
  }

  .t-fee {
    position: relative;
  }
  .slider {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -21px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/PricingForm.vue